import React from 'react';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
import { useTheme } from '@mui/material/styles';

const groups = [
    { cat: 'Languages & Frameworks & libraries', emoji: '💻', skills: ['Java', 'Spring', 'Go', 'JRaft', 'gRPC', 'one-nio'] },
    { cat: 'Messaging & Data', emoji: '📊', skills: ['Apache Kafka', 'PostgreSQL', 'Redis', 'Cassandra', 'S3'] },
    { cat: 'Infrastructure', emoji: '☁️', skills: ['Linux', 'Kubernetes', 'Docker', 'GitLab CI/CD'] },
    { cat: 'Architecture', emoji: '🏗️', skills: ['Microservices', 'System Design', 'Observability', 'Distributed Systems', 'Consensus Algorithms' ] },
];

const SkillsSection: React.FC = () => {
    const theme = useTheme();
    const dark = theme.palette.mode === 'dark';

    return (
        <Box sx={{ py: { xs: 6, md: 10 }, bgcolor: dark ? 'rgba(255,255,255,0.02)' : 'rgba(0,0,0,0.015)' }}>
            <Container maxWidth="lg">
                <Typography variant="h3" sx={{ fontSize: { xs: '1.8rem', md: '2.2rem' }, mb: 1, textAlign: 'center' }}>Tech Stack</Typography>
                <Typography variant="body1" color="text.secondary" sx={{ mb: 6, textAlign: 'center' }}>Technologies I work with daily</Typography>
                <Grid container spacing={3}>
                    {groups.map(g => (
                        <Grid item xs={12} sm={6} key={g.cat}>
                            <Card sx={{ height: '100%', '&:hover': { transform: 'translateY(-2px)' }, transition: 'all 0.3s' }}>
                                <CardContent sx={{ p: 3.5 }}>
                                    <Typography variant="h6" sx={{ mb: 2 }}>{g.emoji} {g.cat}</Typography>
                                    <Stack direction="row" flexWrap="wrap" gap={1}>
                                        {g.skills.map(s => (
                                            <Chip key={s} label={s} size="medium" sx={{ bgcolor: dark ? 'rgba(96,165,250,0.1)' : 'rgba(37,99,235,0.06)', color: dark ? '#93C5FD' : '#2563EB', fontWeight: 500, border: 'none' }} />
                                        ))}
                                    </Stack>
                                </CardContent>
                            </Card>
                        </Grid>
                    ))}
                </Grid>
            </Container>
        </Box>
    );
};

export default SkillsSection;
